import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { SelectableLab } from '../carrier/selectable-lab';
import { AuthUtil } from '../common-services/auth-util';
import * as jwt_decode from 'jwt-decode';
import { LabEmitterService } from '../common-services/lab-emitter.service';
import { NavOpenEmitterService } from '../common-services/nav-open-emitter.service';
import { environment } from '../../environments/environment'
import { OverlayPanel } from 'primeng/overlaypanel';
import { CarrierService } from '../carrier/carrier.service';
import { WorkFlow } from '../masterdata/models/workFlow';
import { MasterDataService } from '../masterdata/masterdata.service';
import { MessagesNewService } from '../messages-new/messages.service';

@Component({
	selector: 'app-navbar',
	templateUrl: './navbar.component.html',
	styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

	viewType: string = '';
	navOpen: boolean = false;
	selectedLab: SelectableLab;
	loggedUserName: string;
    production: boolean;
    buildNo: string;
    sampleProcessingServiceBuildNo : string;
    storageServiceBuildNo : string;
    mdmServiceBuildNo : string;
    deliveryServiceBuildNo : string;
    ngsSamplesProcessingServiceBuildNo : string;
    runPlanningServiceBuildNo : string;
    resultEvaluationServiceBuildNo: string;

	readonly blueberryAPGCologeneReadOnlyUsers = "BlueberryAPGCologeneReadOnlyUsers";
    workFlowData: any[];
    workFlowList: any[];
    isMA: any;
    processFlowData: any[];
    selectedProcessFlows: any[];
	
	constructor(
        private messageService:MessagesNewService,
        private masterDataService: MasterDataService,
        private responsive: BreakpointObserver,
         private router: Router, 
         private labEmitterService: LabEmitterService, 
         private navOpenEmitterService: NavOpenEmitterService,
         private _carrierService: CarrierService
    ) { }

	ngOnInit(): void {
		this.responsive.observe([
			Breakpoints.Handset,
			Breakpoints.Tablet,
			Breakpoints.Web
		]).subscribe(result => {
			const breakpoints = result.breakpoints;
			if (breakpoints[Breakpoints.WebPortrait] || breakpoints[Breakpoints.WebLandscape]) {
				this.viewType = 'web';
			} else if (breakpoints[Breakpoints.TabletPortrait] || breakpoints[Breakpoints.TabletLandscape]) {
				this.viewType = 'tablet';
			} else if (breakpoints[Breakpoints.HandsetPortrait] || breakpoints[Breakpoints.HandsetLandscape]) {
				this.viewType = 'handset';
			}
			this.navOpen = false;
		});
        this.getServiceBuildInfo();
        this.getBuildInfo();
        this.production = environment.production;
        this.selectedLab = JSON.parse(localStorage.getItem('lab') || '{"lab":""}');

        this.labEmitterService.change.subscribe(lab => {
            this.selectedLab = lab;
            console.log("Seleted lab in header(e): " + this.selectedLab.label)
        });
        this.navOpenEmitterService.change.subscribe(navOpen => {
            this.navOpen = navOpen;
        });
        this.getWorkFlowList(this.selectedLab.lab._id);
	}

    getWorkFlowList(labId: string) {
        this.workFlowData = []
        this.workFlowList = []
        let configName = "";
        if (this.isMA)
            configName = "workflow"
        else
            configName = "workflowngs"
        this.masterDataService.getConfigList(labId, configName, 0, 100, true).subscribe({
            next: (results) => {
                this.workFlowData = results.data;
                if(this.workFlowData && this.workFlowData.length>0){
                    this.workFlowData.forEach(e => {
                        this.workFlowList.push({ 
                            label: e.workFlowName, 
                            value: e.workFlowName,
                            selected: false
                        });
                    });
    
                    if(this.workFlowList.length > 0) {
                        localStorage.setItem("workFlowData", JSON.stringify(this.workFlowData));
                        this.workFlowList[0].selected = true;
                        localStorage.setItem("selectedWorkFlow", JSON.stringify(this.workFlowData[0]));
                        this.getProcessFlowData(labId, this.workFlowData[0]);
                    }
                }
            },
            error : (error: any) => {
                this.workFlowData = []
                this.workFlowList = []
                console.log("Failed to load workflows", error)
            }
        });
    }

    getProcessFlowData(labId: string, workFlow: WorkFlow){
        this.processFlowData = [];
        this.selectedProcessFlows = [];
        this.masterDataService.getConfigList(labId, "processFlow", 0, 100, true).subscribe({
            next: (result) => {
                this.processFlowData = result.data;
                if(this.processFlowData.length > 0) {
                    this.processFlowData.forEach(
                        processFlow => {
                          if(workFlow.processFlow?.includes(processFlow.processFlowName))
                            this.selectedProcessFlows.push(processFlow);
                        }
                    );
                    localStorage.setItem("processFlowData", JSON.stringify(this.processFlowData));
                    localStorage.setItem("selectedProcessFlows", JSON.stringify(this.selectedProcessFlows));
                } else {
                    this.messageService.addErrorMessage({
                        severity:"error", summary:"Error while fetching processflows!",
                        detail: "Could not fetch process flows from MDM. " +
                         "Please retry scanning plate. Or check if MDM is configured properly"
                    });
                }
            },
            error: (error) => {
                this.messageService.addErrorMessage({
                    severity:"error", summary:"Error while fetching processflows!",
                    detail: error
                })
            }
        })
    }

    getBuildInfo() {
        console.log("Pulling build info");
        this._carrierService.getBuildInfo().subscribe(
            results => {
                console.log('BUILD: ' + results.Build.Number);
                if (results.Build.Number.length > 0) {
                    this.buildNo = results.Build.Number;
                }
            },
            _error => {
                this.buildNo = '== DEV =='
            }
        );
    }

    getServiceBuildInfo() {

        this._carrierService.getServiceBuildInfo(environment.BB_SAMPLE_PROCESSING_API).subscribe(
            results => {
                console.log("Samples processing service : " + results.Build?.Number);
                this.sampleProcessingServiceBuildNo = results.data.Build?.Number;
            },
            _error => {
                this.sampleProcessingServiceBuildNo = 'N/A'
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_STORAGE_URL).subscribe(
            results => {
                console.log("Storage service:" + results.Build?.Number);
                this.storageServiceBuildNo = results.Build?.Number;
            },
            _error => {
                this.storageServiceBuildNo = 'N/A'
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_MDMSERVICE_URL).subscribe(
            results => {
                console.log("MDM service: " + results?.data.Build.Number);
                this.mdmServiceBuildNo = results?.data.Build.Number;
            },
            _error => {
                this.mdmServiceBuildNo = 'N/A'
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_MA_DELIVERY_API).subscribe(
            results => {
                console.log("MA DELIVERY SERVICE: "+ results?.data.Build.Number);
                this.deliveryServiceBuildNo = results?.data.Build.Number;
            },
            _error => {
                this.deliveryServiceBuildNo = 'N/A'
            }
        )

        this._carrierService.getServiceBuildInfo(environment.BB_APG_SAMPLE_PROCESSING_URL).subscribe(
            results => {
                console.log("MA NGS SAMPLES SERVICE: "+ results?.data.Build.Number);
                this.ngsSamplesProcessingServiceBuildNo = results?.data.Build.Number;
            },
            _error => {
                this.ngsSamplesProcessingServiceBuildNo = 'N/A'
            }
        )

        this._carrierService.getServiceBuildInfo(environment.BB_NGS_RUN_PLANNING_URL).subscribe(
            results => {
                console.log("MA RUN PLANNING SERVICE: "+ results?.data.Build.Number);
                this.runPlanningServiceBuildNo = results?.data.Build.Number;
            },
            _error => {
                this.runPlanningServiceBuildNo = 'N/A'
            }
        )

        this._carrierService.getServiceBuildInfo(environment.BB_RESULT_EVALUATION_URL).subscribe(
            results => {
                console.log("MA RUN PLANNING SERVICE: "+ results?.data.Build.Number);
                this.resultEvaluationServiceBuildNo = results?.data.Build.Number;
            },
            _error => {
                this.resultEvaluationServiceBuildNo = 'N/A'
            }
        )
    }

    showBuildInfo(event, overlaypanel: OverlayPanel) {
        overlaypanel.toggle(event);
    }

	navBarToggle() {
		this.navOpen = !this.navOpen;
        this.navOpenEmitterService.emitNavOpen(this.navOpen);
	}

	isItemSelected(routeLink: string) {
		return this.router.url.includes(routeLink);
	}

	changeLab() {
        localStorage.removeItem('lab');
        localStorage.removeItem('selectedWorkFlow');
        this.router.navigate(['/']).then(nav => {
            console.log(nav); // true if navigation is successful
            if (nav === null) {
                console.log("Reloading...");
                window.location.reload();
            }
        }, err => {
            window.location.reload();
            console.log(err) // when there's an error
        });
    }

	disableHeaderforUser(){
        let roles = this.getRolesFromAccessToken();
        return this.checkIfReadonlyUser(roles);
    }

	checkIfReadonlyUser(roles: any) {
        return (roles.includes(this.blueberryAPGCologeneReadOnlyUsers));
    }

    getRolesFromAccessToken() {
        let authUtil = new AuthUtil();
        let accessToken = authUtil.getAccessToken();
        if (accessToken) {
          let access_token = jwt_decode(accessToken);
          return access_token.roles;
        }
        return [];
    }

	logOut() {
        localStorage.removeItem('currentUser');
    }

    azureLogOut() {
        const util = new AuthUtil()
        util.logout()

    }

	get loginStatus() {
		this.loggedUserName = "User";
        return localStorage.getItem('currentUser') ? true : false;
    }

    get azureLoginStatus() {
        let authUtil = new AuthUtil()
        let accessToken = authUtil.getAccessToken()
        if(accessToken)
        {
            let access_token = jwt_decode(accessToken);
            this.loggedUserName= access_token.name;
            let loggedUserPUID = this.getPUIDFromUPN(access_token.unique_name);
            localStorage.setItem('PUID', loggedUserPUID);
        }
        return accessToken ? true : false
    }

	getPUIDFromUPN(upn: string) {
        return upn.includes('@') ? upn.substring(0, upn.indexOf('@')) : '';
    }
}
